import React from 'react';

import PartyPopperUrl from '@pkg/assets/images/Party_Popper.png';

import { Typography } from '../../DesignSystem';
import { Container, EmojiImage, PrimaryCopySection, Section, TwitterLink } from '../Web3Auth.style';

export function AddTwitterSuccess() {
    return (
        <Container>
            <Section>
                <EmojiImage src={PartyPopperUrl} />
            </Section>

            <PrimaryCopySection>
                <Typography type="headline" size={40}>
                    You&apos;re all ready to go,
                    <br />
                    <TwitterLink href="#thecryptobro">@thecryptobro</TwitterLink>
                </Typography>

                <Typography type="paragraph" size={18} faded={true}>
                    Now get out there and start collecting!
                </Typography>
            </PrimaryCopySection>
        </Container>
    );
}
